import { Alert, Badge } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { getStatusLabelKey } from '../../../app/helpers/documentationWikiHelper';

const DocHeaderCard = ({ frontmatter, manifestDoc, showPdfButton, exportingPdf, onExportPdf }) => {
  const { t } = useTranslation();
  const status = frontmatter.status || manifestDoc?.status || 'published';

  return (
    <div className="docs-header-card">
      <div className="docs-header-top">
        <div>
          <h1 className="docs-title">{frontmatter.title || manifestDoc?.label || manifestDoc?.id}</h1>
          <div className="docs-meta-row">
            <Badge bg="secondary">{t(getStatusLabelKey(status))}</Badge>
            {frontmatter.version && (
              <span className="docs-meta-item">
                {t('docs.meta.version')}: <strong>{frontmatter.version}</strong>
              </span>
            )}
            {frontmatter.updatedAt && (
              <span className="docs-meta-item">
                {t('docs.meta.updatedAt')}: <strong>{frontmatter.updatedAt}</strong>
              </span>
            )}
            {frontmatter.author && (
              <span className="docs-meta-item">
                {t('docs.meta.author')}: <strong>{frontmatter.author}</strong>
              </span>
            )}
          </div>
        </div>

        {showPdfButton && (
          <button
            type="button"
            className="btn btn-outline-primary docs-pdf-btn docs-no-print"
            onClick={onExportPdf}
            disabled={exportingPdf}
          >
            <i className={`fa ${exportingPdf ? 'fa-spinner fa-spin' : 'fa-file-pdf-o'}`} />
            {' '}
            {exportingPdf ? t('docs.exportPdfGenerating') : t('docs.exportPdf')}
          </button>
        )}
      </div>

      {(status === 'deprecated' || status === 'historic') && (
        <Alert variant="warning" className="docs-deprecated-alert">
          {t('docs.deprecated.message')}
          {(frontmatter.supersededBy || manifestDoc?.supersededBy) && (
            <>
              {' '}
              <Link to={`/documentation/${frontmatter.supersededBy || manifestDoc.supersededBy}`}>
                {t('docs.deprecated.viewReplacement')}
              </Link>
            </>
          )}
        </Alert>
      )}
    </div>
  );
};

export default DocHeaderCard;
